/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{formatNumber as t}from"../../../../intl.js";function n(n){const{percentAlong:r}=n;return null==r?"":t(r,{style:"percent",maximumFractionDigits:2})}export{n as formatPercentAlong};
